import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import { Menu } from "../../../../constants/jsonConstant";
import "./leftmenu.css";
import { getAsset } from "../../../../helpers/helper";
import { useSelector } from "react-redux";
import userAvatarImg from "../../../../assets/images/dummy/user-avatar-img.jpg";
import BackArrow from "../../../../components/backArrow";

const Leftmenubar = ({
  userdash = 0,
  setUserdash,
  userimg,
  isUserimgLoading,
  activeShopTab: propActiveShopTab,
  setActiveShopTab: propSetActiveShopTab,
  managedShops = [],
  pendingInvitations = [],
  selectedManagedShopId: propSelectedManagedShopId,
  setSelectedManagedShopId: propSetSelectedManagedShopId,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [internalActiveShopTab, setInternalActiveShopTab] = useState("created");
  const [internalSelectedManagedShopId, setInternalSelectedManagedShopId] =
    useState(null);

  const activeShopTab =
    propActiveShopTab !== undefined ? propActiveShopTab : internalActiveShopTab;
  const setActiveShopTab = propSetActiveShopTab || setInternalActiveShopTab;

  const selectedManagedShopId =
    propSelectedManagedShopId !== undefined
      ? propSelectedManagedShopId
      : internalSelectedManagedShopId;
  const setSelectedManagedShopId =
    propSetSelectedManagedShopId || setInternalSelectedManagedShopId;

  const name = useSelector((state) => state?.user?.name);

  const getAvatarSource = () => {
    if (Array.isArray(userimg) && userimg.length > 0) {
      const firstImg = userimg[0];
      if (
        typeof firstImg === "string" &&
        firstImg.trim() &&
        firstImg.trim() !== "null"
      ) {
        return getAsset(firstImg.trim());
      }
    } else if (
      typeof userimg === "string" &&
      userimg.trim() &&
      userimg.trim() !== "null"
    ) {
      return getAsset(userimg.trim());
    }
    return userAvatarImg;
  };

  return (
    <>
      {location.pathname !== "/SellingSide" &&
        location.pathname !== "/user-dashboard" && (
          <div className="business-dashboard-mobile-back d-lg-none">
            <BackArrow back="/SellingSide" />
          </div>
        )}
      <Col
        lg="12"
        md="12"
        className={
          location.pathname === "/user-dashboard"
            ? "bg-blue-lg screenHeight leftcomheighttt"
            : "bg-blue-lg screenHeight h-100 business-dashboard-sidebar"
        }
      >
        <div className="">
          <Col lg="10" className=" b-radius mx-auto pt-3 pb-3">
            <div className="profileImgbusiness d-flex justify-content-center">
              {isUserimgLoading ? (
                <div className="profileImgbusiness-skeleton" />
              ) : (
                <img
                  src={getAvatarSource()}
                  alt={name?.fullname || "User avatar"}
                  crossOrigin="anonymous"
                  className="profileImgbusiness-avatar"
                  onError={(ev) => {
                    ev.currentTarget.onerror = null;
                    ev.currentTarget.src = userAvatarImg;
                  }}
                />
              )}
            </div>

            <div className="Name pt-4 pb-4 card-title text-center text-white">
              <h5 className="m-0">{name?.fullname}</h5>
            </div>
          </Col>
        </div>
        {location.pathname === "/user-dashboard" ? (
          <>
            <div
              className="shopDashboardTabs"
              role="tablist"
              aria-label="Shop type"
            >
              <button
                type="button"
                role="tab"
                aria-selected={activeShopTab === "created"}
                className={`shopDashboardTab ${
                  activeShopTab === "created" ? "shopDashboardTabActive" : ""
                }`}
                onClick={() => {
                  setActiveShopTab("created");
                  if (setSelectedManagedShopId) setSelectedManagedShopId(null);
                  if (setUserdash) setUserdash(1);
                }}
              >
                My Created shops
              </button>
              <button
                type="button"
                role="tab"
                aria-selected={activeShopTab === "managed"}
                className={`shopDashboardTab ${
                  activeShopTab === "managed" ? "shopDashboardTabActive" : ""
                }`}
                onClick={() => {
                  setActiveShopTab("managed");
                  if (setSelectedManagedShopId) setSelectedManagedShopId(null);
                  if (setUserdash) setUserdash(0);
                }}
              >
                Managed Shops
              </button>
            </div>

            <hr
              className="shopDashboardDivider"
              style={{
                border: "none",
                borderTop: "1px solid #ffffff",
                height: "0px",
                opacity: 1,
                margin: "12px 0 16px",
                width: "100%",
              }}
            />

            {activeShopTab === "managed" ? (
              managedShops && managedShops.length > 0 ? (
                <div className="ps-2">
                  {managedShops.map((membership) => {
                    const shop = membership.shopId;
                    if (!shop) return null;
                    const isSelected =
                      String(selectedManagedShopId) === String(shop._id) ||
                      String(selectedManagedShopId) === String(membership._id);
                    return (
                      <Col
                        key={membership._id}
                        md={11}
                        lg={12}
                        sm={11}
                        xs={12}
                        xl={12}
                        className={`d-flex pe-0 justify-content-center justify-content-sm-center justify-content-md-start cursor_P managed-shop-item ${
                          isSelected ? "managed-shop-item-active" : ""
                        }`}
                        onClick={() => {
                          if (setSelectedManagedShopId) {
                            setSelectedManagedShopId(
                              selectedManagedShopId === shop._id ? null : shop._id,
                            );
                          }
                          if (setUserdash) setUserdash(0);
                        }}
                      >
                        <div className="mt-2 mb-0">
                          <EqualizerIcon style={{ color: "white" }} />
                        </div>
                        <ul style={{ listStyle: "none" }} className="ps-2 mb-2">
                          <li
                            className="text-white setfonts font-lg mt-2 text-truncate"
                            style={{ maxWidth: "160px" }}
                          >
                            {shop.shopname}
                          </li>
                        </ul>
                      </Col>
                    );
                  })}
                  {pendingInvitations && pendingInvitations.length > 0 && (
                    <div className="text-warning small px-3 py-2">
                      {pendingInvitations.length} pending invite
                      {pendingInvitations.length > 1 ? "s" : ""}
                    </div>
                  )}
                </div>
              ) : pendingInvitations && pendingInvitations.length > 0 ? (
                <div className="text-warning small px-3 py-3 text-center">
                  {pendingInvitations.length} pending invite
                  {pendingInvitations.length > 1 ? "s" : ""} awaiting response.
                </div>
              ) : (
                <div className="managedShopsPlaceholder" role="status">
                  You don't have any managed shops yet.
                </div>
              )
            ) : (
              <div className="ps-2">
                <Col
                  md={11}
                  lg={12}
                  sm={11}
                  xs={12}
                  xl={12}
                  className="d-flex pe-0  justify-content-center  justify-content-sm-center justify-content-md-start  cursor_P"
                >
                  <div className="mt-2 mb-0">
                    <SpeakerNotesIcon style={{ color: "white" }} />
                  </div>

                  <ul style={{ listStyle: "none" }} className="ps-2 mb-2">
                    <li
                      className="text-white setfonts font-lg mt-2"
                      onClick={() => setUserdash && setUserdash(1)}
                    >
                      Suggestions replies
                    </li>
                  </ul>
                </Col>

                <Col
                  md={11}
                  lg={12}
                  sm={11}
                  xs={12}
                  xl={12}
                  className="d-flex pe-0  justify-content-center  justify-content-sm-center justify-content-md-start  cursor_P"
                >
                  <div className="mt-2 mb-0">
                    <SpeakerNotesIcon style={{ color: "white" }} />
                  </div>

                  <ul style={{ listStyle: "none" }} className="ps-2 mb-2">
                    <li
                      className="text-white setfonts font-lg mt-2"
                      onClick={() => setUserdash && setUserdash(4)}
                    >
                      Report replies
                    </li>
                  </ul>
                </Col>

                <Col
                  md={11}
                  lg={12}
                  sm={11}
                  xs={12}
                  xl={12}
                  className="d-flex pe-0  justify-content-center  justify-content-sm-center justify-content-md-start  cursor_P"
                >
                  <div className="mt-2 mb-0">
                    <EqualizerIcon style={{ color: "white" }} />
                  </div>

                  <ul style={{ listStyle: "none" }} className="ps-2 mb-2">
                    <li
                      className="text-white setfonts font-lg mt-2"
                      onClick={() => setUserdash && setUserdash(5)}
                    >
                      Adds Statistic
                    </li>
                  </ul>
                </Col>
              </div>
            )}
          </>
        ) : (
          <div className="mx-auto col-10">
            <Col lg="12" className="ps-0 pe-0 mb-3 businessItemsScroll">
              {Menu.map((e) => (
                <div
                  key={e.id || e.to}
                  className={`menu-item-wrapper ${location.pathname === e.to ? "menu-item-active" : ""}`}
                  onClick={() => navigate(e.to)}
                >
                  <div className="w-100 p-0">
                    <Row>
                      <Col
                        md="12"
                        lg="12"
                        sm="12"
                        xs="12"
                        className="d-flex pe-0"
                      >
                        <div className="mt-2 mb-0">
                          <img src={e.icon} alt="" className="menuimg-width" />
                        </div>

                        <ul style={{ listStyle: "none" }} className="ps-2 mb-2">
                          <li className="leftmenu_sett text-white font-lg mt-2">
                            {e.text}
                          </li>
                        </ul>
                      </Col>
                    </Row>
                  </div>
                </div>
              ))}
            </Col>
          </div>
        )}
      </Col>
    </>
  );
};
export default Leftmenubar;
